export default "__VITE_ASSET__Bt6yf4XW__"